import { useCallback } from 'react';

const useIntegrityAdvocate = (
	appId: string,
	courseId: string,
	participantIdentifier: string,
	activityId: string,
) => {
	// Очищення cookies після завершення сесії
	const clearCookies = () => {
		const cookiesToDelete = [
			'integrityadvocate_step',
			'integrityadvocate_activityid',
			'integrityadvocate_participantidentifier',
			'integrityadvocate_basicmodecomplete',
			'integrityadvocate_bypassauth',
			'integrityadvocate_drag_position',
			'integrityadvocate_sebmatch',
		];

		cookiesToDelete.forEach((cookie) => {
		document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
		});

		console.log('Cookies очищено.');
	};

	// Видалення контейнера UI
	const resetUI = () => {
		let elem = document.getElementById('integrityadvocate_container');
		if (elem) elem.remove();

		elem = document.getElementById('integrityadvocate_tab');
		if (elem) elem.remove();

		console.info('UI оновлено.');
	};

	const endSession = useCallback(async () => {
		if ((window as any).IntegrityAdvocate && typeof (window as any).IntegrityAdvocate.endSession === 'function') {
			console.info('Викликається window.IntegrityAdvocate.endSession()');
			(window as any).IntegrityAdvocate.endSession();
		} else {
			console.info('Integrity Advocate не ініціалізований, виконується API-запит...');
			const url = `https://ca.integrityadvocateserver.com/participants/endsession?appid=${appId}&courseid=${courseId}&participantidentifier=${participantIdentifier}&activityid=${activityId}`;

			try {
				const response = await fetch(url);
				if (response.status === 200) {
				console.info('Сесію успішно завершено.');
				} else {
				console.error(`Помилка завершення сесії: ${response.status}`);
				}
			} catch (error) {
				console.error('Помилка підключення:', error);
			}
		}

		clearCookies();
		resetUI();
	}, [appId, courseId, participantIdentifier, activityId]);

	return { endSession };
};

export default useIntegrityAdvocate;
